import * as Sentry from '@sentry/react';
import { Environment } from 'environmentVariables';

if (Environment === 'production') {
    Sentry.init({
        dsn: 'https://36307ccaab1d14810c1740867f068b32@o974849.ingest.sentry.io/4505704769781760',
    });
}
